import React from 'react';
import { Navigate } from 'react-router-dom';

interface Props {}

const LogoutPage: React.FC<Props> = () => {
  window.location.assign('/api/auth/signout');
  return <Navigate to="/" />;
};

export default LogoutPage;
